import { useEffect } from 'react';

import useUser from 'api/hooks/useUser';
import profileMutation from 'api/mutations/profileMutation';

export default function useForceGreenLanguageAndCurrency() {
  const { data: user } = useUser();
  const { mutate } = profileMutation();

  useEffect(() => {
    if (!user || !user.greenLang || !user.greenCurrency) {
      return;
    }

    if (user?.greenLang?.toLowerCase() !== 'french'
      || user?.greenCurrency?.code?.toLowerCase() !== 'eur') {
      mutate({
        greenLang: 'French',
        blueLang: user?.blueLang,
        blueCurrency: user?.blueCurrency,
        greenCurrency: { code: 'EUR' },
      });
    }
  }, [user?.greenLang, user?.greenCurrency]);
}